var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('redeem-flow-info',{staticClass:"mt-5"}),(_vm.$vuetify.breakpoint.xsOnly)?_c('swap-auth-and-register',{staticClass:"mt-5",staticStyle:{"width":"-webkit-fill-available"}}):_c('auth-and-register',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }